"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedDiscountResponseDtoExceptProductsAndPriceList = exports.mockedDiscountWithoutProductsResponseDto = exports.mockedDiscountsResponse = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const omit_util_1 = require("../../utils/omit.util");
const discount_for_product_participation_1 = require("../discount-for-product-participation");
const product_1 = require("../product");
exports.mockedDiscountsResponse = {
  id: 1,
  code: 'code',
  title: 'title',
  typeOfDiscount: common_interfaces_1.DiscountType.discount,
  typeOfCalculation: common_interfaces_1.DiscountCalculationType.fixedAmount,
  amount: 10,
  isDeleted: false,
  currency: common_interfaces_1.Currency.euro,
  condition: common_interfaces_1.DiscountTerms.participationInProjects,
  conditionValue: '',
  isCalculateWithOtherDiscounts: false,
  isSummarizeQuantity: false,
  beginningDate: new Date('10-11-2019'),
  endDate: new Date('10-11-2021'),
  products: [product_1.mockedProductWithoutDiscountsResponseDto],
  productsToBeParticipated: [],
  priceList: [],
  productParticipation: [discount_for_product_participation_1.mockedDiscountForProductParticipationResponse],
  oldId: null
};
exports.mockedDiscountWithoutProductsResponseDto = omit_util_1.omitObject(exports.mockedDiscountsResponse, 'products');
exports.mockedDiscountResponseDtoExceptProductsAndPriceList = omit_util_1.omitObject(exports.mockedDiscountsResponse, 'products', 'priceList');